export default __webpack_public_path__ + "static/media/redandfly.1d59d1f5.png";